module.exports = __webpack_public_path__ + "assets/media/facebook-color.c3efc104.svg";